export const check_customer_existency_api = "users/booking/existency";
export const generate_otp_api = "payments/generate/generic/otp";
export const verify_otp_api = "payments/verify/generic/otp";
export const request_tokens_api = "eud/auth/token";
